// import useReversedFeatureFlag from '@/utils/hooks/useFeatureFlag';

// const FEATURE_FLAG_KEY = 'SHIPMENT_TRACKER';
const useShipmentTrackerFeatureFlag = () => {
  // const isAvailable = useReversedFeatureFlag(FEATURE_FLAG_KEY, {
  //   dev: true,
  //   uat: true,
  // });

  return true;
};
export default useShipmentTrackerFeatureFlag;
